import {
  FETCHING_MAP_PROJECTS,
  FETCHED_MAP_PROJECTS,
  FETCHED_MAP_PROJECTS_ERROR,
  FETCHED_MAP_PROJECT_BY_ID,
} from 'constants/actions';

const mapProjectsById = (projects) =>
  projects.reduce((projectsById, project) => {
    return {
      ...projectsById,
      [project.id]: project,
    };
  }, {});

const projects = (state = {}, action = {}) => {
  switch (action.type) {
    case FETCHED_MAP_PROJECTS:
      return mapProjectsById(action.payload.data);

    case FETCHED_MAP_PROJECT_BY_ID:
      const fetchedProjectId = action.payload.id;
      const stateProject = state[fetchedProjectId];

      const updatedProject = {
        ...stateProject,
        ...action.payload,
      };

      return {
        ...state,
        [fetchedProjectId]: updatedProject,
      };

    default:
      return state;
  }
};

export default projects;
